import { jsx as _jsx } from "react/jsx-runtime";
import CopyrightCheckerOverview from '../overzicht/CopyrightCheckerOverview';
const DossiersOverviewForwarder = (props) => {
    return _jsx(CopyrightCheckerOverview, { ...props, data: props.domains });
};
export default DossiersOverviewForwarder;
